import { createQueryKey } from 'src/utils/query/createQueryKey';

export const GC_TIME_MS = 5 * 60 * 1000;

export const accountTradingDataQueryKeys = {
	marginInfo: () => createQueryKey('accountMarginInfo'),
	positions: () => createQueryKey('accountPositions'),
	orders: () => createQueryKey('accountOrders'),
	leftoverIsolatedPositions: () =>
		createQueryKey('accountLeftoverIsolatedPositions'),
};
